<template>
  <div>
    <div v-show="!isLandscape || isFullScreen" class="detail">
      <span v-show="!isFullScreen" class="icon" @click.prevent="back">
        <svg-icon icon-class="back" />
      </span>

      <div v-show="!isLandscape || isFullScreen" class="detail">
        <span v-show="!isFullScreen" class="icon" @click.prevent="back">
          <svg-icon icon-class="back" />
        </span>
        <div class="player" :style="{ width: `${width}px`, height: `${height}px` }">
          <div v-if="limit" class="course-tip">
            授权数量达到上限
          </div>
          <template v-else-if="courseInfo.sc_flow_down && isStart">
            <node-player
              :src="getLivePath"
              :live="true"
              :end="liveEnd"
              @onFullScreen="handleFullScreen"
              @onError="urlError"
            />
            <!-- <m-player
              :src="getLivePath"
              :live="true"
              :end="liveEnd"
              @onFullScreen="handleFullScreen"
              @onError="urlError"
            /> -->
          </template>
          <div v-else class="course-tip">
            <!-- <count-down
              v-if="courseInfo.sc_start_time"
              :startTime="courseInfo.sc_start_time"
              @endHandler="endHandler"
            ></count-down>-->
            {{ tips }}
          </div>
        </div>
        <comments
          v-show="!isFullScreen"
          ref="comments"
          @changeTip="tipChangeHandle"
          @update="getCourseInfo"
        />
      </div>
    </div>
    <div class="landscape" v-show="isLandscape && !isFullScreen">请使用竖屏观看课程</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import api from '@/api/live';
import playerMixin from '@/mixins/player';
import Comments from './comments';
import MPlayer from '@/components/MPlayer/Index.vue';
import NodePlayer from '@/components/MPlayer/nodePlayer.vue';
import { isMobile, isLandscape } from '@/utils/index.js';

export default {
  name: 'live-detail',
  components: {
    MPlayer,
    NodePlayer,
    Comments
  },
  data() {
    return {
      isStart: false,
      tips: '老师正在准备课程，请耐心等待',
      isMobile: true,
      liveEnd: false,
      isLandscape: false,
      isFullScreen: false,
      limit: false,
      showComment: true,
      timer: null
    };
  },
  mixins: [playerMixin],
  computed: {
    ...mapGetters(['courseInfo', 'userInfo']),

    getLivePath() {
      const pathObj = JSON.parse(this.courseInfo.sc_flow_down);
      console.log('pathObj == ', pathObj);
      return pathObj.livePlayHlsUrl;
    }
  },
  created() {
    // 再次获取课程信息，防止用户直接分享该页
    this.getCourseInfo();

    this.timer = setInterval(() => {
      console.log(123123123);
      this.getCourseInfo();
    }, 3000);
  },
  mounted() {
    this.isMobile = isMobile();
    this.backToLogin();
    this.isLandscape = isLandscape();
    document.title = this.courseInfo.sc_name;
    this.isStart = this.courseInfo.master_enter === 1;
    this.addListener();
  },
  methods: {
    // getLimit(schoolName) {
    //   api.fetchLimit({ schoolName }).then(res => {
    //     if (res.code == 0) {
    //       if (Number(res.result.onlineUsers) > Number(res.result.maxOnlineUsers)) {
    //         // 当前观看人数超过最大观看人数，限流
    //         this.limit = true;
    //       }
    //     }
    //   });
    // },
    getLimit(code) {
      api.fetchLimit({ guid: code }).then(res => {
        if (res.success) {
          // if (Number(res.result.onlineUsers) > Number(res.result.maxOnlineUsers)) {
          if (Number(res.data.onlineUsers) > Number(res.data.maxOnlineUsers)) {
            // 当前观看人数超过最大观看人数，限流
            this.limit = true;
          }
        }
      });
    },
    addListener() {
      window.addEventListener('orientationchange', () => {
        // 窗口大小变化
        this.isLandscape = isLandscape();
      });
    },
    handleFullScreen(isFullScreen) {
      this.isFullScreen = isFullScreen;
    },
    back() {
      // this.$router ? this.$router.back() : window.history.back();
      const time = new Date().getTime();
      this.$router.push({
        path: `/home?code=${this.$route.params.code}&time=${time}`
      });
    },
    endHandler() {
      this.isStart = true;
    },
    tipChangeHandle(type) {
      const that = this;
      if (!type) {
        // 因为流延迟问题，直播结束后延迟30秒结束
        that.liveEnd = true;
        setTimeout(() => {
          that.isStart = type;
          that.tips = '老师已下课，谢谢观看';
        }, 30 * 1000);
      } else {
        this.isStart = type;
      }
    },
    urlError() {
      // this.isStart = false;
      this.tips = this.liveEnd ? '老师已下课，谢谢观看' : '休息一下，等老师回来';
      if (this.tips === '老师已下课，谢谢观看') {
        this.isStart = false;
      }
    },
    /**
     * 获取课程信息
     */
    getCourseInfo() {
      const code = this.$route.params.code;
      const params = {
        guid: code
      };
      api
        .fetchCourseInfo(params)
        .then(response => {
          // 保存课程信息到store
          if (response.success) {
            this.$store.commit('SET_COURSE_INFO', response.data);
            this.isStart = this.courseInfo.master_enter === 1;
            this.$refs.comments.disabledMessage = response.data.sc_silent_status === '2';

            console.log('this.courseInfo: ', this.courseInfo);
            // this.getLimit(this.courseInfo.sc_school_name);
            if (this.courseInfo.sc_flow_down && this.isStart) {
              clearInterval(this.timer);
            }
            this.getLimit(code);

            // 如果课程结束，返回签到页
            if (response.data.sc_status === '3') {
              this.back();
            }
          } else {
            this.$store.commit('SET_COURSE_INFO', {});
            this.showToast(response.message);
          }
        })
        .catch(err => {
          this.$store.commit('SET_COURSE_INFO', {});
          // this.showToast('获取课程信息失败');
        });
    },

    /**
     * 显示提示信息
     */
    showToast(msg) {
      this.$createToast({
        time: 1000,
        type: 'txt',
        txt: msg
      }).show();
    },
    // 如果不是mobile，则返回登录页
    backToLogin() {
      if (!this.isMobile) {
        this.back();
      }
    }
  },
  watch: {
    'courseInfo.sc_status'() {
      this.isStart = this.courseInfo.master_enter === 1;
    }
  }
};
</script>

<style lang="less">
.detail {
  flex-direction: column;
  position: relative;
  font-size: 16px;

  .icon {
    position: absolute;
    left: 15px;
    top: 15px;
    z-index: 1001;
    color: #fff;
    font-size: 18px;
  }

  .player {
    background: #000;

    .course-tip {
      font-size: 14px;
      color: #ccc;
      padding-top: 90px;
    }

    .reload {
      .reload-btn {
        font-size: 13px;
        width: 20%;
        height: 24px;
        line-height: 24px;
        border-radius: 22px;
        margin: 20px auto;
        text-align: center;
        padding: 0;
      }
    }
  }

  // #live-video {
  //   -webkit-transform: rotate(90deg);
  //   -moz-transform: rotate(90deg);
  //   -ms-transform: rotate(90deg);
  //   -o-transform: rotate(90deg);
  //   transform: rotate(90deg);
  // }

  .vcp-error-tips {
    margin-top: -2.25em;
  }
}
.landscape {
  position: fixed;
  width: 100vw;
  height: 100vh;
  line-height: 100vh;
  text-align: center;
  background-color: #000;
  color: #fff;
  font-size: 16px;
  z-index: 99999;
}
</style>
